import { equals, pathOr, pipe } from 'ramda';

export const isHttpError = (e: any) => !!e.response && !!e.config;

export const isHttpNoResponseError = (e: any) => !e.response && !!e.config;

export const isNonHttpError = (e: any) => !e.response && !e.config;

export const getHttpStatus = (e: any) => {
  if (isHttpError(e)) {
    return e.response.status;
  }
  return null;
};

export const getErrorHttpStatus = pathOr(0, ['response', 'status']);
export const isHttpErrorStatus = (status: number) =>
  pipe(getErrorHttpStatus, equals(status));

export const isConflictHttpError = isHttpErrorStatus(409);

export const isNotFoundHttpError = isHttpErrorStatus(404);

export const isBadRequestHttpError = isHttpErrorStatus(400);

export const isNotAuthorizedHttpError = isHttpErrorStatus(403);

export const getDescription = (e: any) => {
  if (!!e.response && !!e.response.data && !!e.response.data.description) {
    return e.response.data.description;
  }
  return null;
};
